import {IPrimaryKey} from "../interfaces/iprimary-key";

export class EspecialidadePrimaryKey implements IPrimaryKey<EspecialidadeModel> {
  seq_Setor: number = 0;
  seq_Clinica: number = 0;

  get id(): string {
    return `seqSetor/${this.seq_Setor}/seqClinica/${this.seq_Clinica}`;
  }
}

export class EspecialidadeModel extends EspecialidadePrimaryKey {
  seq_Estab: number = 0;
  descricao_Clinica: string = '';
}
